module.exports = __webpack_public_path__ + "static/img/akum_600_120.4fdba02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_120.svg
// module id = vC3R
// module chunks = 1